import { render } from "./PriorityMatrix.vue?vue&type=template&id=0a42cc79"
import script from "./PriorityMatrix.vue?vue&type=script&lang=js"
export * from "./PriorityMatrix.vue?vue&type=script&lang=js"

import "./PriorityMatrix.vue?vue&type=style&index=0&id=0a42cc79&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__